import { csvEscape, filterLabelFromList, safeCsvSlug, triggerCsvDownload } from './perfHubCsvUtils';

const READINESS_LABELS = {
  good: 'Looks good',
  review: 'Review suggested',
  not_live: 'Post not live',
  awaiting_sync: 'Awaiting sync',
  // Legacy alias.
  not_connected: 'Awaiting sync',
};

function normalizeReadiness(readiness) {
  if (readiness === 'good' || readiness === 'green') return 'good';
  if (readiness === 'not_live') return 'not_live';
  if (readiness === 'awaiting_sync' || readiness === 'not_connected') return 'awaiting_sync';
  return 'review';
}

function formatChecks(checks) {
  if (!checks?.length) return '';
  return checks
    .map((c) => `${c.label || c.id} [${c.status}]: ${c.message || ''}`)
    .join(' | ');
}

function countByStatus(checks, status) {
  return (checks || []).filter((c) => c.status === status).length;
}

/**
 * Build CSV for Post Guard rows (already filtered by UI).
 */
export function buildPostGuardCsvRows(posts) {
  const headers = [
    'instagram_handle',
    'status',
    'readiness',
    'permalink',
    'media_type',
    'summary_reasons',
    'checks_pass',
    'checks_fail',
    'checks_warn',
    'checks_detail',
    'suggested_creator_message',
    'row_id',
  ];

  const lines = [headers.map(csvEscape).join(',')];

  for (const p of posts) {
    const checks = p.checks || [];
    const bucket = normalizeReadiness(p.readiness);
    lines.push(
      [
        p.instagram_handle,
        p.readiness_label || READINESS_LABELS[bucket] || bucket,
        bucket,
        p.permalink,
        p.media_type,
        (p.reasons || []).join('; '),
        countByStatus(checks, 'pass'),
        countByStatus(checks, 'fail'),
        countByStatus(checks, 'warn'),
        formatChecks(checks),
        p.creator_fix_message,
        p.row_id,
      ]
        .map(csvEscape)
        .join(','),
    );
  }

  return lines.join('\n');
}

export function downloadPostGuardCsv(posts, { campaignName, filterId, filters }) {
  if (!posts?.length) return;

  const filterLabel =
    filterLabelFromList(filters, filterId) || READINESS_LABELS[filterId] || 'All';

  const safeCampaign = safeCsvSlug(campaignName);
  const safeFilter = filterLabel.replace(/[^\w.-]+/g, '_').toLowerCase();
  triggerCsvDownload(`post-guard-${safeCampaign}-${safeFilter}.csv`, buildPostGuardCsvRows(posts));
}
